import type { TransactionsBundleExecuteResponse } from "../../lib/api";
import { cn } from "../../lib/cn";

export function ExecutionBlock({
	data,
}: {
	data: TransactionsBundleExecuteResponse;
}) {
	const ex = data.execution;
	const ok = ex.ok;
	return (
		<div
			className={cn(
				"space-y-1 rounded-md border p-3 text-[11px]",
				ok
					? "border-emerald-700/50 bg-emerald-950/30"
					: "border-rose-900/60 bg-rose-950/40",
			)}
		>
			<p
				className={cn(
					"font-semibold uppercase tracking-wide",
					ok ? "text-emerald-300" : "text-rose-300",
				)}
			>
				{ok ? "Executed" : "Execution failed"}
			</p>
			{!ok && <p className="text-rose-200/80">{ex.reason}</p>}
			{ex.bundles.length > 0 && (
				<ul className="space-y-1 font-mono text-[11px] text-slate-300">
					{ex.bundles.map((b) => (
						<li
							key={b.txHash}
							className="flex items-center justify-between gap-2"
						>
							<a
								href={`https://etherscan.io/tx/${b.txHash}`}
								target="_blank"
								rel="noreferrer"
								className="truncate text-emerald-300 hover:underline"
							>
								{b.txHash.slice(0, 10)}…{b.txHash.slice(-6)}
							</a>
							<span
								className={
									b.status === "success" ? "text-emerald-300" : "text-rose-300"
								}
							>
								{b.status}
							</span>
						</li>
					))}
				</ul>
			)}
		</div>
	);
}
